export class BaseStoreManager {
  // constructor(dbManager, dbName, storeName) {
  constructor(dbManager, storeName) {
    this.dbManager = dbManager;
    // this.dbName = dbName;
    this.storeName = storeName;
    // this.dbManager.openDB(this.dbName, [this.storeName]);
    // this.dbManager.ensureStoreExists(this.storeName);
  }

  async addItem(id, data) {
    return new Promise(async (resolve, reject) => {

      this.dbManager.executeOperation(this.storeName, (store) => {
        const request = store.add(data, id);

        request.onsuccess = resolve;
        request.onerror = reject;
      });

    });
  }

  async putItem(id, data) {
    return new Promise(async (resolve, reject) => {

      this.dbManager.executeOperation(this.storeName, (store) => {
        const request = store.put(data, id);

        request.onsuccess = resolve;
        request.onerror = reject;
      });

    });
  }

  async hasItem(id) {

    // debugger

    try {
      let item = await this.getItem(id);

      if (!item) return false;

      return true;
    } catch(e) {
      //todo check error type and then rethrow maybe here

      return false;
    }

    return new Promise(async (resolve, reject) => {

      this.dbManager.executeOperation(this.storeName, (store) => {
        const request = store.get(id);

        request.onsuccess = () => {
          const data = request.result;
          resolve(data);
        };

        request.onerror = reject;
      });

    });
  }

  async getItem(id) {
    return new Promise(async (resolve, reject) => {

      this.dbManager.executeOperation(this.storeName, (store) => {
        const request = store.get(id);

        request.onsuccess = () => {
          const data = request.result;
          resolve(data);
        };

        request.onerror = reject;
      });

    });
  }

  async updateItem(id, updatedItem) {
    return new Promise(async (resolve, reject) => {

      this.dbManager.executeOperation(this.storeName, (store) => {
        const request = store.get(id);

        request.onsuccess = () => {
          const data = request.result;
          Object.assign(data, updatedItem);
          store.put(data, id);

          //TODO wait put operation before resolve
          resolve();
        };

        request.onerror = reject;
      });

    });
  }

  async deleteItem(id) {
    return new Promise(async (resolve, reject) => {

      this.dbManager.executeOperation(this.storeName, (store) => {
        const request = store.delete(id);

        request.onsuccess = resolve;
        request.onerror = reject;
      });

    });
  }
}


//TODO move to base class here
// this.requestCache = new Map; // id -> promise ///TODO seems irrelevant to class IndexedDBManager (could be renamed to Facade already)

